import { createMongoAbility, type MongoQuery, type SubjectRawRule } from '@casl/ability';
import { unpackRules } from '@casl/ability/extra';
import type { PackedRule } from '@movo/contracts/api/auth';

// Le regole arrivano impacchettate da login e /api/auth/me: qui si scompattano
// soltanto, il frontend non le ricalcola.
export const buildAbility = (packedRules: PackedRule[] | undefined) =>
  createMongoAbility(unpackRules<SubjectRawRule<string, string, MongoQuery>>(packedRules ?? []));

export type AppAbility = ReturnType<typeof buildAbility>;

export const EMPTY_ABILITY = buildAbility(undefined);
